<template>
  <div class="text-question">
    <h2>
      <span class="no">
        {{index}}.
    </span>
      {{ question }}
    </h2>
    <div class="input-text">
      <input :type="inputType" class="ans-apply" placeholder="Type your answer here" v-model="ans" @keypress.enter="answered" :key="index">
    </div>
    <small>{{hint}}</small>

    <div class="btn-wrapper">
    <button class="btn btn-primary" @click="answered" v-if="validate">
      Next
    </button>
  </div>
  </div>
</template>

<script>
export default {
  name: "TextQuestion",
  props: {
    question: {
      type: String,
      required: true
    },
    minLength: {
      type: Number,
      default: 1
    },
    index: {
      type: Number,
      required: true
    },
    inputType: {
      type: String,
      default: 'text'
    },
    hint: {
      type: String
    }
  },
  data(){
    return{
      ans:'',
      emailReg: /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/

    }
  },
  methods: {
    answered(){

      if (this.validate) {
        this.$emit('answered', {
          index: this.index,
          ans:this.ans, ques: this.question
        })
      }
    }
  },
  computed: {
    validate(){
      if(this.inputType==='text'&&this.ans.length >=this.minLength){
        return true
      }else if(this.inputType==='email' && this.emailReg.test(this.ans)){
        return true
      }
      return false
    }
  }
}
</script>
<style lang="scss" scoped>
.text-question {
  h2 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    color: #52595E;
    margin-bottom: 25px;
    max-width: 375px;
    position: relative;
  }
  .input-text{
    padding-left: 26px;
    position: relative;
    @media (max-width: 600px) {
      padding-left: 0;
    }
    &::before {
      position: absolute;
      content: "";
      width: 0;
      height: 0;
      right: 50%;
      top: 99%;
      border-bottom: 2px solid #474d52;
      transition: all 0.1s ease;
    }
    &::after {
      position: absolute;
      content: "";
      width: 0;
      height: 0;
      left: 50%;
      top: 99%;
      border-bottom: 2px solid #474d52;
      transition: all 0.1s ease;
    }
  }


  .ans-apply {
    width: 100%;
    border: none;
    border-bottom: 1px solid #8D99A0;
    background: none;
    height: 36px;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    color: #52595E;
    position: relative;

    &:focus, &:active, &:hover {
      outline: none;
      //border-color: #52595E;

    }

    &::-webkit-input-placeholder { /* Edge */
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #8D99A0;
    }

    &:-ms-input-placeholder { /* Internet Explorer 10-11 */
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #8D99A0;
    }

    &::placeholder {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #8D99A0;
    }
  }
  .btn-wrapper{
    height: 78px;
  }
  .btn{
    margin-top: 33px;
    box-shadow: none;
    border-radius: 32px;
    text-transform: capitalize;
    letter-spacing:1px;
    padding: 10px 25px;
    margin-left: 26px;
    @media (max-width: 600px) {
      margin-left: auto;
      margin-right: auto;
      display: block;
    }
    &:hover{
      background: #557efb;
      box-shadow: 0 13px 27px 0 rgba(85, 126, 251, 0.75);
    }
    &::after,
    &::before{
      content: none
    }
  }
  small {
    margin-top: 8px;
    font-size: 12px;
    font-style: normal;
    font-weight: normal;
    display: block;
    padding-left: 26px;
    text-transform: capitalize;
      @media (max-width: 600px) {
    padding-left: 2px;
  }
  }
}
</style>
